import type { DraftState, TeamState } from '../../types/protocol'

// Who is up next. DraftState has no on_deck field — that only rides along on
// cable events, which the board never sees individually — so it is derived
// here from the pending picks after the current overall. Two names is the
// useful depth: enough warning to get your phone out, short enough to fit
// beside a clock that owns most of the header.

const DEPTH = 2

interface Props {
  draft: DraftState
}

export default function OnDeckStrip({ draft }: Props) {
  const upcoming = nextTeams(draft, DEPTH)
  if (upcoming.length === 0) return null

  return (
    <div className="flex min-w-0 flex-col gap-[0.3vh]">
      <p className="text-board-label font-mono font-semibold tracking-[0.3em] text-signal uppercase">
        On deck
      </p>
      {upcoming.map(({ overall, team }) => (
        <p
          key={overall}
          className="text-board-team font-display truncate leading-tight font-semibold"
        >
          <span className="text-ink-lo tabular-nums">#{overall}</span>{' '}
          <span className="text-ink-mid">{team?.name ?? 'TBD'}</span>
        </p>
      ))}
    </div>
  )
}

export function nextTeams(
  draft: DraftState,
  depth: number,
): Array<{ overall: number; team: TeamState | null }> {
  const current = draft.current_pick_overall
  if (current == null) return []

  const teamsById = new Map(draft.teams.map((team) => [team.id, team]))

  return draft.picks
    .filter((pick) => pick.status === 'pending' && pick.overall > current)
    .sort((a, b) => a.overall - b.overall)
    .slice(0, depth)
    .map((pick) => ({ overall: pick.overall, team: teamsById.get(pick.team_id) ?? null }))
}
